"use client"

import styled from "@emotion/styled"
import { useTranslations } from "next-intl"
import React, { useEffect } from "react"

const StyledBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: white;
  box-shadow: 0px 0px 17.3px 0px rgba(114, 111, 111, 0.3);

  ${(props) => props.theme.breakpoints.up("md")} {
    display: none;
  }
`

const StyledButton = styled.button`
  width: 100%;
  height: 46px;
  border-radius: 45px;
  border: 1px solid #0000fa;
  background: white;
  color: #0000fa;
  font-size: 18px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
`

type StickyBottomBarProps = {
  onClick: () => void
  label?: string
}

export default function StickyBottomBar({ onClick, label }: StickyBottomBarProps) {
  const t = useTranslations("portMeetingRoomProduct")

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 899px)")
    const update = () => {
      document.body.style.paddingBottom = mq.matches ? "78px" : ""
    }
    update()
    mq.addEventListener("change", update)
    return () => {
      mq.removeEventListener("change", update)
      document.body.style.paddingBottom = ""
    }
  }, [])

  return (
    <StyledBar>
      <StyledButton onClick={onClick}>{label || t("selectRoom")}</StyledButton>
    </StyledBar>
  )
}
